import * as MobX from "mobx";
import { InitialState } from "../Models";
import { runInAction } from "mobx";
import { StoresInstance } from "../Stores";
import { deleteJWT, isJWTValid, ViewModelBase } from "@shoothill/core";

export class InitViewModel extends ViewModelBase<any> {
    @MobX.observable
    public DataReady: boolean = false;
    public InitData: InitialState = {} as InitialState;
    constructor() {
        super({});
    }

    public getInitialState = async (): Promise<boolean> => {
        if (!isJWTValid()) {
            deleteJWT();
        }
        let apiResult = await this.Get<InitialState>("/api/initialstate/getinitialstatejson");
        runInAction(() => {
            // if (!apiResult.payload.accountStatus.isLoggedIn) {
            // 	StoresInstance.domain.AccountStore.Logout(false);
            // }
            StoresInstance.init(apiResult.payload);
            this.InitData = apiResult.payload;
            this.DataReady = true;
        });
        return apiResult.wasSuccessful;
    };

    public async isFieldValid(fieldName: "emailAddress" | "password", value: any): Promise<boolean> {
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
